import {Type} from '@github-ui/react-query-persister/typebox'
import {Compile} from '@github-ui/react-query-persister/typebox/compile'

export const ViewConfigurationPayloadSchema = Type.Object({
  layout: Type.Union([Type.Literal('list'), Type.Literal('board')]),
  groupBy: Type.Union([Type.String(), Type.Null()]),
  swimlaneBy: Type.Union([Type.String(), Type.Null()]),
  sorts: Type.ReadonlyObject(
    Type.Array(
      Type.Object({
        field: Type.String(),
        direction: Type.Union([Type.Literal('asc'), Type.Literal('desc')]),
      }),
    ),
  ),
  visibleFields: Type.ReadonlyObject(Type.Array(Type.String())),
})
export type ViewConfigurationPayload = Type.Static<typeof ViewConfigurationPayloadSchema>

export const viewConfigurationValidator = Compile(ViewConfigurationPayloadSchema)

export function isViewConfiguration(value: unknown): value is ViewConfigurationPayload {
  return viewConfigurationValidator.Check(value)
}
